module.exports = __webpack_public_path__ + "img/file-chart.b4d3cd6a.svg";